module.exports = __webpack_public_path__ + "img/circulo-obtener.16179d1b.png";